export const getQueryParams = (queryParams, customQueryParams, publisher) => {
    return {
        ...(customQueryParams || queryParams),
        publisher
    };
};
